import { IAttachment } from '~/client/graph'
import { getAttachmentFileType } from '~/client/src/shared/components/WorkflowCard/fileAttachmentHelpers'
import FileType from '~/client/src/shared/enums/FileType'
import IFilePreviewProperties from '~/client/src/shared/interfaces/IFilePreviewProperties'

import { downloadFile } from './util'

const DOWNLOAD_ONLY_TYPES: FileType[] = [
  FileType.Excel,
  FileType.PowerPoint,
  FileType.Word,
  FileType.OtherFile,
]

const PREVIEWABLE_TYPES: FileType[] = [
  FileType.Image,
  FileType.Video,
  FileType.Pdf,
]

function toFilePreviewProperties(
  attachments: IAttachment[],
): IFilePreviewProperties[] {
  return attachments.map(a => ({
    fileUrl: a.url,
    fileType: getAttachmentFileType(a.fileName) as FileType,
    fileName: a.fileName,
  }))
}

/**
 * Opens a file preview for the attachment at the given index.
 * Downloads non-previewable types (Excel, Word, PPT, Other).
 * Calls `showPreview` for previewable types (Image, PDF).
 */
export function openAttachmentPreview(
  attachments: IAttachment[],
  index: number,
  showPreview: (files: IFilePreviewProperties[], index: number) => void,
): void {
  const attachment = attachments[index]
  if (!attachment) return

  const fileType = getAttachmentFileType(attachment.fileName) as FileType
  if (DOWNLOAD_ONLY_TYPES.includes(fileType)) {
    downloadFile(attachment.fileName, attachment.url)
    return
  }

  const previewable = attachments.filter(a =>
    PREVIEWABLE_TYPES.includes(getAttachmentFileType(a.fileName) as FileType),
  )
  const remappedIndex = previewable.indexOf(attachment)
  if (previewable.length === 0 || remappedIndex < 0) return

  showPreview(toFilePreviewProperties(previewable), remappedIndex)
}
